import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupId } from '../../models/popup.model';
import { DownloadAppDialogComponent } from '../../components/dialogs/download-app-dialog/download-app-dialog.component';
import { NewFeaturesDialogComponent } from '../../components/dialogs/new-features-dialog/new-features-dialog.component';
import { ReferralDialogComponent } from '../../components/dialogs/referral-dialog/referral-dialog.component';
import { EarlyAccessFeatureDialogComponent } from '../../../portfolio-manager/components/dialogs/early-access-feature-dialog/early-access-feature-dialog.component';
import { AddonsDialogComponent } from '../../../taxation/components/dialogs/addons-dialog/addons-dialog.component';
import {
  acknowledgePopupAction,
  goToAction,
  pushTagAction,
  togglePlansPageAction,
  trackEventAction,
} from '../../store/actions/shared.action';
import { select, Store } from '@ngrx/store';
import * as fromShared from '../../store/selectors/shared.selector';
import { Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlansPageComponent } from '../../../taxation/pages/plans-page/plans-page.component';
import { TaxSeasonEndDialogComponent } from '../../../taxation/components/dialogs/tax-season-end-dialog/tax-season-end-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserPreferences } from '../../models/user-preferences.model';

@Component({
  selector: `app-popup-page`,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    EarlyAccessFeatureDialogComponent,
    NewFeaturesDialogComponent,
    AddonsDialogComponent,
    ReferralDialogComponent,
    PlansPageComponent,
    DownloadAppDialogComponent,
    TaxSeasonEndDialogComponent,
  ],
  templateUrl: `./popup-page.component.html`,
  styleUrl: `./popup-page.component.scss`,
})
export class PopupPageComponent implements OnInit, OnDestroy {
  popupId: PopupId;
  upgradeFishing: string;
  voucher: string;

  showPlansPage: boolean;
  userPreferences: UserPreferences;

  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private readonly sharedStore$: Store<fromShared.State>,
  ) {}

  ngOnInit(): void {
    this.popupId = this.route.snapshot.params[`id`];
    this.upgradeFishing = this.route.snapshot.queryParams[`upgradeFishing`];

    this.trackEvent();
    this.checkPopup();

    this.sharedStore$
      .pipe(
        takeUntil(this.destroy$),
        select(fromShared.selectShowPlansPage),
        map((showPlansPage: boolean) => {
          this.showPlansPage = showPlansPage;
        }),
      )
      .subscribe();

    this.sharedStore$.pipe(
      takeUntil(this.destroy$),
      select(fromShared.selectUserPreferences),
      map((userPreferences: UserPreferences) => {
        this.userPreferences = userPreferences;
      }),
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkPopup(): void {
    if (this.popupId === `MKT-CAMPAIGN-2025-APRIL`) {
      this.voucher = `APRIL25`;

      this.sharedStore$.dispatch(togglePlansPageAction());
    }

    if (this.popupId === `MKT-WELCOMEBACK-IN-2024`) {
      this.voucher = `WELCOMEBACK25`;

      this.sharedStore$.dispatch(togglePlansPageAction());
    }
  }

  closePlansPage(): void {
    this.sharedStore$.dispatch(togglePlansPageAction());

    this.sharedStore$.dispatch(
      acknowledgePopupAction({
        popupId: this.popupId,
        acknowledgedFrom: `DESKTOP`,
      }),
    );

    this.back();
  }

  back(): void {
    this.sharedStore$.dispatch(goToAction({ url: `/dashboard` }));
  }

  trackEvent(): void {
    this.sharedStore$.dispatch(
      trackEventAction({
        event: `upgrade_fishing`,
        data: {
          upgrade_name: this.upgradeFishing,
        },
      }),
    );
  }
}
